<template>
  <div id="app">
    <Header @scrollToForm="scrollToForm">
      <div v-if="currentView.name == 'Home'">
        <h1 class="mb-10 mt-0 md:mt-10">
          Connect individuals with<span class="hidden md:inline"><br /></span>
          peers for support &amp;<span class="hidden md:inline"><br /></span>
          referral to services
        </h1>
        <Button
          @clicked="scrollToForm"
          :className="'shadow'"
          :text="'Make the Connection'"
        />
      </div>
      <div v-if="currentView.name == 'PrivacyPolicy'">
        <h1 class="mb-10 mt-0 md:mt-10">
          <img class="mb-4" src="./assets/images/connections-text-white.png" />
          Privacy Policy
        </h1>
      </div>
    </Header>
    <component @scrollToForm="scrollToForm" :is="currentView" />
    <Footer>
      <p>
        <a href="/#/privacy-policy" v-if="currentView.name == 'Home'">Privacy Policy</a>
        <a href="/#/" v-if="currentView.name == 'PrivacyPolicy'">Home</a>
      </p>
    </Footer>
  </div>
</template>

<script>
import Home from "./pages/Home.vue";
import PrivacyPolicy from "./pages/PrivacyPolicy.vue";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import Button from "./components/Button.vue";

const routes = {
  "/": Home,
  "/privacy-policy": PrivacyPolicy,
};

export default {
  name: "App",
  components: {
    // imported components
    Header,
    Footer,
    Button,
  },
  data() {
    return {
      currentPath: window.location.hash,
    };
  },
  computed: {
    currentView() {
      return routes[this.currentPath.slice(1) || "/"]; //|| NotFound
    },
  },
  mounted() {
    window.addEventListener("hashchange", () => {
      window.scrollTo(0, 0);
      this.currentPath = window.location.hash;
    });
  },
  methods: {
    // component functions
    scrollToForm() {
      let form = document.getElementById("form");
      window.scroll({
        top: form.offsetTop,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style>
@font-face {
  font-family: "Gotham Pro";
  src: url("./assets/font/Gotham Pro Regular.ttf");
}
#app {
  font-family: "Gotham Pro";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  background: #fff;
  font-size: 14px;
  min-height: 100vh;
}
</style>
